"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrompts = void 0;
const react_1 = require("react");
const prompt_context_1 = require("./prompt-context");
function usePrompts(prompts, deps = []) {
    const { registerPrompts, unregisterPrompts } = (0, react_1.useContext)(prompt_context_1.PromptContext);
    const previousPromptsRef = (0, react_1.useRef)([]);
    (0, react_1.useEffect)(() => {
        const previousPrompts = previousPromptsRef.current;
        const nextPromptKeys = new Set(prompts.map(({ key }) => key));
        const removedPrompts = previousPrompts.filter(({ key }) => !nextPromptKeys.has(key));
        registerPrompts(prompts);
        if (removedPrompts.length > 0) {
            unregisterPrompts(removedPrompts);
        }
        previousPromptsRef.current = prompts;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    (0, react_1.useEffect)(() => {
        return () => {
            unregisterPrompts(previousPromptsRef.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
exports.usePrompts = usePrompts;
//# sourceMappingURL=prompt-register-hook.js.map